export function saveLinks(state){
  return {
    type: 'SAVE_LINKS',
    payload: state
  }
}